import {forwardRef, useEffect, useImperativeHandle, useMemo, useState} from 'react';
import dayjs from 'dayjs';
import SelectBox from 'devextreme-react/select-box';
import {DatePeriodSelectorProps} from '../types/DatePeriodSelectorProps';
import {DatePeriodSelectorRef} from "../types/DatePeriodSelectorRef";

const datePeriodSelector = forwardRef<DatePeriodSelectorRef, DatePeriodSelectorProps>((props: DatePeriodSelectorProps, ref: React.Ref<DatePeriodSelectorRef>) => {

    const datePeriods = useMemo(() => {
        return [
            {id: 0, name: "90 Days", dateFrom: dayjs().subtract(90, 'day').toDate()},
            {id: 1, name: "6 Months", dateFrom: dayjs().subtract(6, 'month').toDate()},
            {id: 2, name: "1 Year", dateFrom: dayjs().subtract(1, 'year').toDate()},
            {id: 3, name: "2 Years", dateFrom: dayjs().subtract(2, 'year').toDate()},
            {id: 4, name: "3 Years", dateFrom: dayjs().subtract(3, 'year').toDate()},
            {id: 5, name: "Entire History", dateFrom: null}
        ];
    }, []);

    const [periodID, setPeriodID] = useState(props.defaultPeriodID ?? 0);
    useEffect(() => {
        if (props.visible ?? true) {
            props.onPeriodChanged();
        }
    }, [props.visible, periodID]);

    const onDropDownChanged = (value: number) => {
        setPeriodID(value);
    };

    useImperativeHandle(ref, () => ({
        getPeriod: () => datePeriods[periodID].dateFrom
    }));
    return (
        <SelectBox
            value={periodID}
            valueExpr="id"
            displayExpr="name"
            dataSource={datePeriods}
            onValueChanged={e => onDropDownChanged(e.value)}
            visible={props.visible ?? true}
        />
    )
})

export default datePeriodSelector;